import { getPaymentsByMonthReq } from "./payments/paymentReq";

export const ApiKey = {
  // =========WEB=========================================
  //------------- auth keys -------------
  getOtpByMailKey: "/user/sendloginotp",
  loginWithMailKey: "/user/authenticate",
  setPasswordKey: "/user/setPassword",
  registerUserKey: "/user/register",
  getSignUpOtpkey: "/user/sendSignUpOTP",
  resendSignUpOtpkey: "/user/resendSingUpOTP",
  verifyOtpKey: "/user/verifyOTP",
  // ---have doubt on using this-----
  resendOtpKey: "/user/resendloginotp",
  getOtpKey: "/user/sendloginotp",
  loginWithOtpKey: "/user/loginWithOTP",

  //------------- user keys -------------
  profileKey: "/user/getProfile",
  fetchCandidateDetailsKey: "/company/get/details",
  deleteCandidateDetailsKey: "/company/delete/details",

  // -----------clients----------------
  createPaymentsKey: "/payments/create",
  getPaymentsKey: "/company",
  updateCompanyStatus: "/company", // /company/companyID/status

  // -----------payments----------------
  getAllTransactionKey: "/company/payments/tilldates",
  getPaymentsByMonthKey: "/company/payments/month",
  getAllPaymentsKey: "/company/payments/all",

  // -----------E-Admin----------------
  get_eAdminListKey: "/user/EAdmin",
  createEAminKey: "/company/profile",

  // -----------CEP-Admin----------------
  newCEPAdminKey: "/company/cepAdmin/create",
  getCEPsListKey: "/user/CEP",
  deleteCEPbyIdKey: "/company/cepAdmin/delete", // /company/cepAdmin/delete/:CEPid
  updateCEPbyIdKey: "/company/cepAdmin/update", // /company/cepAdmin/update/:CEPid

  // -----------comapny----------------
  getCompanyListKey: "/company/list",
  getCompanyDetailsByIdKey: "/company", // /company/details/companyID
  getCompanyStatsByIdKey: "/company", // /company/companyID/stats

  // ---------other------------------
  plansListKey: "/subscriptions/plans",
  getPlansListKey: "/subscriptions/details",
  updateSubscriptionDetailsKey: "/company", // /company/companyID/subscription
  refreshTokenKey: "/user/refreshToken",
  contactUskey: "/company/CEP", //companyID
  dashboardStatsKey: "/company/allstats",
  cepDashboardStatsKey: "/company/list",

  // ==========================================================
};
